/**
 * Created by Udara Prabath
 * Date: 10/20/2020
 * Using: IntelliJ IDEA
 */
import React from 'react';
import './Landing.scss'
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router";
import {Container, Row, Col} from "reactstrap";

// core components
import Header from "../../../components/Header/Header";
import AuthButtonGroup from "../../../components/AuthButtonGroup/AuthButtonGroup";
import SectionPolygon from "../../../components/SectionPolygon/SectionPolygon";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as actionInstituteCreator from "../../../store/domain/institute/action";
import * as instituteService from "../../../services/institute";
import * as commonFunc from "../../../utils/commonFunc";
import TeachersSlides from "../../../components/TeachersSlides/TeachersSlides";
import NotFound from "../../../components/NotFound/NotFound";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import {Carousel} from 'react-responsive-carousel';

class Landing extends React.Component{

    fetchInstituteTeachers = async () => {
        this.props.spinnerHandler({ isSpin: true, type: 15 });
        await instituteService.getInstituteTeachers()
            .then(response => {
                this.props.spinnerHandler(false);
                if (response.success) {
                    this.props.fetchTeachers(response.body.teachers);
                } else {
                    commonFunc.notifyMessage(response.message, response.status)
                }
            })
    }

    async componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
        await this.fetchInstituteTeachers();
    }

    render() {
        let { institute, teachers, userType } = this.props;
        return(
            <div>
                <Header active={0}/>
                <main ref="main" className={"landing"}>

                    <section className="profile-layer">
                        <Carousel
                            autoPlay
                            showThumbs={false}
                        >
                            <div>
                                <img
                                    src={'https://www.freepik.com/blog/app/uploads/2020/02/1270x720-PIN-BLOG-PIN-BLOG-15-Education-Related-Resources-to-Enjoy-Learning.jpg'}
                                    alt={"."}
                                    className={"blur-img"}/>
                                <img
                                    src={'https://www.freepik.com/blog/app/uploads/2020/02/1270x720-PIN-BLOG-PIN-BLOG-15-Education-Related-Resources-to-Enjoy-Learning.jpg'}
                                    alt={"."}
                                    className={"slideshow-pro-image"}/>
                            </div>
                        </Carousel>


                        <img src={institute.defaultImage} className={"profile-image"} alt="."/>
                    </section>

                    <section className="section name">

                        <div className="about mb-3 pl-lg-8 pr-lg-8 pb-2">
                            <h3 className={"name-row1"}>{institute.name}</h3>
                            <p className={"name-row2 none-margin_"}>{institute.qualification}</p>
                        </div>

                        <div className="about2">
                            <h3 className={"class-topic"}>About</h3>
                            <p className={"about-para"}>{institute.about}</p>
                        </div>
                    </section>

                    {
                        teachers.length !== 0 ?  (
                                 <section className=" class-section">
                                     <div className="about2">
                                         <h3 className={"class-topic"}>Teachers</h3></div>
                                     <TeachersSlides
                                         teachers={teachers}
                                         history={this.props.history}
                                     />
                                </section>
                        ) : !this.props.isSpinner && <NotFound message={`Teachers`} />
                    }
                </main>

                <CardsFooter />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    institute: state.institute.institute,
    teachers: state.institute.teachers,
    userType: state.auth.userType,
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    fetchTeachers: data => dispatch(actionInstituteCreator.fetchTeachers(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Landing));
